import React from 'react';
import styled from 'styled-components';
import { SectionParent, H2 } from '../../StyledComponents';
import { Title } from '../HomePage/HomepageSectionOne';
const Section = styled(SectionParent)`
  background: #181e43;
  padding-top: 4rem !important;
  padding-bottom: 8rem !important;
  margin-top: 6rem;
  display: grid;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 4rem !important;
  }
`;
const SectionOneTitleMain = styled(Title)`
  color: #fff;
  margin-left: 2rem;
  width: 60%;
  display: grid;
  justify-content: center;
  margin-bottom: 0rem;
  @media (max-width: 520px) {
    text-align: justify;
    margin-left: 1.5rem;
  }
`;
const SectionOneTitle = styled(H2)`
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  width: 64%;
  display: grid;
  justify-self: center;
  line-height: normal;
  letter-spacing: normal;
  text-align: justify;
  color: #e1e0ea;
  /* width: 95%; */
  margin-left: 2rem;
  @media (min-width: 1600px) {
    width: 62%;
  }
  @media (max-width: 800px) {
    width: 71%;
  }
  @media (max-width: 520px) {
    text-align: justify;
    width: 85%;
    margin-left: 1.5rem;
  }
`;

export default ({ messages }: any) => (
  <Section>
    <div>
      <SectionOneTitleMain>
        {messages?.AboutUsPageTitle}
        <br />
        <br />
      </SectionOneTitleMain>
    </div>
    <SectionOneTitle>
      {messages?.AboutUsPageDesc1}
      <br />
      <br />
      {messages?.AboutUsPageDesc2}
    </SectionOneTitle>
  </Section>
);
